<template>
  <div id="app_content" class="admin">
    <h1 class="page-title">Gestione costi di spedizione</h1>

    <div class="catalog page-section">
      <div class="list">
        <h2 class="mt-0">Listini inseriti nel B2B</h2>

        <div v-if="listini && listini.length > 0" class="catalog-list">
          <div class="row" v-for="listino in listini" :key="listino.id">
            <div
              class="col-md-8 col-8 my-title"
              :class="selected === listino.id ? color : ''"
            >
              <span class="m-0"
                ><strong>{{ listino.nome }}</strong></span
              >
              <small> - {{ listino.descrizione }}</small>
            </div>
            <div class="col-md-2 col-2">
              <button
                class="blue-link"
                @click="editListino(listino.id)"
                @mouseover="hover(listino.id, 'orange')"
                @mouseleave="leave()"
              >
                <i class="fas fa-pen orange"></i>
              </button>
            </div>
            <div class="col-md-2 col-2">
              <button
                class="red-link"
                @click="elimina_listino = listino"
                @mouseover="hover(listino.id, 'red')"
                @mouseleave="leave()"
              >
                <i class="fas fa-trash red"></i>
              </button>
            </div>
          </div>
        </div>

        <span v-else class="empty">...nessun listino ancora creato</span>
      </div>

      <button class="belt-btn" @click="newListino()">Aggiungi listino</button>
    </div>
    <div class="modal-new-listino" v-if="openNewListino && list">
      <addListino
        :listini="listini"
        @closeAdd="openNewListino = false"
        @verify="verify(name)"
        @inserito="success"
      />
    </div>
    <div class="modal-new-listino" v-if="openEditListino && list">
      <editListino
        :idListino="currentEditListino"
        @refreshed="refresh"
        :key="editKey"
        @close="openEditListino = false"
      />
    </div>


    <div class="conferma" v-if="elimina_listino != null">
      <div class="modal-white container">
        <div class="row">
          <h1 class="col-md-12">
            Sei sicuro di voler cancellare il listino:
            {{ elimina_listino.nome }}?
          </h1>
          <div class="col-md-3">
            <button class="belt-btn" @click="elimina_listino = null">
              Annulla
            </button>
          </div>
          <div class="col-md-9">
            <button class="belt-btn" @click="delListino(elimina_listino.nome)">
              Prosegui con la cancellazione
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="messaggio-successo" v-if="messaggio != ''">
      {{ messaggio }}
    </div>

    <!-- <div class="messaggio" v-if="messaggio != ''">
      <button @click="messaggio = ''" class="belt-btn my-green-btn">
        {{ messaggio }}
      </button>
    </div> -->
  </div>
</template>

<script>
import addListino from "./add-listino";
import editListino from "./edit-listino";

export default {
  components: { addListino, editListino },

  data: function () {
    return {
      messaggio: "",
      listini: [],
      editor_listino: null,
      elimina_listino: null,
      openNewListino: false,
      openEditListino: false,
      currentEditListino: null,
      list: false,
      editKey: 0,
      selected: null,
      color: null,
    };
  },

  methods: {
    hover: function (id, color) {
      this.selected = id;
      this.color = color;
    },
    leave: function () {
      this.selected = null;
      this.color = null;
    },

    success: function (msg) {
    this.$store.commit('add_message', {
        type: 'success',
        message: msg
      });
      this.loadData();

    },
    refresh: function () {
      this.editKey++;
    },
    editListino: function (id) {
      this.currentEditListino = id;
      this.openEditListino = !this.openEditListino;
    },
    newListino: function () {
      this.openNewListino = !this.openNewListino;
    },
    delListino: function (nome) {
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "delete-listino",
          name: nome,
        },
      })
        .then((res) => {
          this.elimina_listino = null;
          this.success("Il listino " + nome + " è stato cancellato");
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },

    loadData() {
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "read",
        },
      })
        .then((res) => {
          if (res.data.listini) this.listini = res.data.listini;
          this.list = true;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
  },

  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.messaggio-successo {
  position: absolute;
  display: inline-block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  padding: 50px;
  background-color: var(--green);
}

.page-section {
  margin-top: 4em;
  width: 100%;
  padding: 10px;
  background-color: var(--background-gray);
}

.catalog-list {
  width: 100%;
  margin-top: 30px;
  strong {
    color: inherit;
  }
  small {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.catalog-list button {
  margin-left: auto;

  &:hover {
    text-decoration: none;
  }
}

.modal-new-listino {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  padding-top: 100px;
  height: 100vh;
  width: 100vw;
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  .modal-white {
    background-color: #fff;
    height: fit-content;
    padding-top: 20px;
    padding-bottom: 20px;
  }
}

.messaggio {
  position: fixed;
  top: 0;
  left: 0;
  padding-top: 100px;
  height: 100vh;
  width: 100vw;
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
  }
}

@media (min-width: 576px) {
  .page-section {
    padding: 2em;
  }
}
</style>
